interface ViewFieldProps {
  label: React.ReactNode;
  value?: React.ReactNode;
}

const ViewField: React.FC<ViewFieldProps> = ({ label, value }) => {
  return (
    <div className='flex flex-col gap-1'>
      <span className='text-[14px] text-[var(--textBlack56)]'>{label}</span>
      <span className='text-[16px] font-medium text-[var(--textBlack)]'>{value || '--'}</span>
    </div>
  );
};

export default ViewField;
